'use client';
import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgShapes = function SvgShapes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.946 15.26a3.362 3.362 0 1 1-4.754 4.755 3.362 3.362 0 0 1 4.754-4.755M21.254 7.153l-2.898 2.898a1.12 1.12 0 0 1-1.585 0l-2.898-2.898a1.12 1.12 0 0 1 0-1.584L16.77 2.67a1.12 1.12 0 0 1 1.585 0l2.898 2.898a1.12 1.12 0 0 1 0 1.585M4.318 9.53h4.098c.62 0 1.121-.503 1.121-1.122V4.31c0-.619-.502-1.12-1.12-1.12H4.317c-.619 0-1.12.501-1.12 1.12v4.098c0 .62.501 1.121 1.12 1.121M5.365 15.156 2.88 19.132a1.182 1.182 0 0 0 1.002 1.808h4.969a1.182 1.182 0 0 0 1.002-1.808L7.37 15.157a1.182 1.182 0 0 0-2.005 0",
    vectorEffect: "non-scaling-stroke"
  })));
};

export { SvgShapes as default };
//# sourceMappingURL=shapes.svg.js.map
